import { render } from "./MapSubsection.vue?vue&type=template&id=5436a722&ts=true"
import script from "./MapSubsection.vue?vue&type=script&lang=ts"
export * from "./MapSubsection.vue?vue&type=script&lang=ts"

import "./MapSubsection.vue?vue&type=style&index=0&id=5436a722&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__